/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import useCustomMutationReactQuery from '../generalHooks/useCustomMutationReactQuery'
import { getUserList, updatePostById } from '../../apiProcess/sampleApi'
import _ from 'lodash'
import { loginProcess, otpProcess } from '@/utility/apiProcess/auth/login'
import { toast } from 'react-toastify'
import { getDetailEvents, getPastEvents, getUpcomingEvents, registerEvent } from '@/utility/apiProcess/events'

const useEvnetQuery = () => {
  // get upcoming events list
	const [upcomingEventsData, setUpcomingEventsData] = useState<any>([])
  const {
		isLoading: loadingUpcomingEvents,
		return_data: upcomingEventsDataRaw,
		startFetch: startUpcomingEvents,
	} = useCustomMutationReactQuery(getUpcomingEvents, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(upcomingEventsDataRaw)) {
			const data:any = []
			upcomingEventsDataRaw.data.data.map((item: any) => {
				data.push({
					title: item.title,
					description: item.short_description,
					image: item.banner,
					date: item.date,
					id: item.id,
					onClick: () => console.log("PUSH 2"),
				},)
			})
			setUpcomingEventsData(data)
		}
	},[upcomingEventsDataRaw])

	// get past events list
	const [pastEventsData, setPastEventsData] = useState<any>([])
	const [isSearch, setIsSearch] = useState<any>(false)
	const [pastEventPageInfo, setPastEventPageInfo] = useState<any>([])
  const {
		isLoading: loadingPastEvents,
		return_data: PastEventsDataRaw,
		startFetch: startPastEvents,
	} = useCustomMutationReactQuery(getPastEvents, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(PastEventsDataRaw) && PastEventsDataRaw.status === 200) {
			const data:any = []
			PastEventsDataRaw.data.data.map((item: any) => {
				data.push({
					title: item.title,
					description: item.short_description,
					image: item.banner,
					date: item.date,
					id: item.id,
					onClick: () => console.log("PUSH 2"),
				},)
			})

			if(isSearch) {
				setPastEventsData(data)
			} else {
				setPastEventsData((prev:any) => [...prev, ...data])
			}
			setPastEventPageInfo(PastEventsDataRaw.data.infoPage)
		} 
	},[PastEventsDataRaw])

	// get upcoming events list
	const [eventDetail, setEventDetail] = useState<any>({})
	const [eventDetailRelated, setEventDetailRelated] = useState<any>([])
  const {
		isLoading: loadingEventDetail,
		return_data: eventDetailRaw,
		startFetch: startEventDetail,
	} = useCustomMutationReactQuery(getDetailEvents, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(eventDetailRaw)) {
			setEventDetail(eventDetailRaw.data.data)
			setEventDetailRelated(eventDetailRaw.data.related_events)
		}
	},[eventDetailRaw])

	// register event
  const {
		isLoading: loadingRegisterEvent,
		return_data: registerEventData,
		startFetch: startRegisterEvent,
	} = useCustomMutationReactQuery(registerEvent, {
		onError: (error: any) => toast.error(error.data.message),
    isStartOnInit: false,
	})

	return {
		loadingUpcomingEvents,
		loadingPastEvents,
    upcomingEventsData,
    startUpcomingEvents,
		startPastEvents,
		pastEventsData,
		startEventDetail,
		eventDetail,
		setIsSearch,
		pastEventPageInfo,
		eventDetailRelated,
		startRegisterEvent,
		registerEventData,
		loadingEventDetail
	}
}

export default useEvnetQuery
